import { render, staticRenderFns } from "./callServiceCategory.vue?vue&type=template&id=59d62c2a&scoped=true&"
import script from "./callServiceCategory.vue?vue&type=script&lang=js&"
export * from "./callServiceCategory.vue?vue&type=script&lang=js&"
import style0 from "./callServiceCategory.vue?vue&type=style&index=0&id=59d62c2a&prod&lang=css&"
import style1 from "./callServiceCategory.vue?vue&type=style&index=1&id=59d62c2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d62c2a",
  null
  
)

export default component.exports